/** @format */

import React, { useEffect, useState } from "react";
import PhoneNumbersOverviewView from "./PhoneNumbersOverview.view";
import { IAccountPhoneNumbers } from "../MainContent.types";
import { useQueryAccounts } from "../../../apis/swr/fetchers";

interface IPhoneNumbersOverviewContainerProps {
	setRemountHelper: React.Dispatch<React.SetStateAction<boolean>>;
}

function PhoneNumbersOverviewContainer({
	setRemountHelper,
}: IPhoneNumbersOverviewContainerProps) {
	const [accountPhoneNumbers, setAccountPhoneNumbers] = useState<
		IAccountPhoneNumbers[]
	>([]);
	const { accounts, isLoading } = useQueryAccounts();

	useEffect(() => {
		const getPhoneNumbers = () => {
			if (accounts) {
				const phoneData: IAccountPhoneNumbers[] = [];
				accounts.forEach((account) => {
					if (account.phoneNumbers) {
						account.phoneNumbers.forEach((number) => {
							const numberData = {
								accountId: account.accountId,
								webName: account.webName,
								phoneNumber: number,
							};
							phoneData.push(numberData);
						});
					}
				});
				setAccountPhoneNumbers(phoneData);
			}
		};

		getPhoneNumbers();
	}, [accounts]);

	return (
		<PhoneNumbersOverviewView
			setRemountHelper={setRemountHelper}
			accountPhoneNumbers={accountPhoneNumbers}
			isLoading={isLoading}
		/>
	);
}

export default PhoneNumbersOverviewContainer;
